'use client'
import React from 'react'
import { store } from './store'
import { Provider } from 'react-redux'

export function Providers({ children }) {
  return React.createElement(Provider, { store: store }, children)
}
